<div class="address-autocomplete">
  @if (label) {
    <label class="form-label">
      @if (required) { <span class="text-danger">*</span> }
      {{ label }}
    </label>
  }
  <input
    type="text"
    class="form-control"
    [placeholder]="placeholder"
    [ngModel]="value"
    (ngModelChange)="onInput($event)"
    (focus)="showSuggestions = suggestions.length > 0"
    (blur)="hideSoon()"
    autocomplete="off"
    [required]="required" />

  @if (loading) {
    <small class="address-autocomplete__hint text-muted">{{ 'addressAutocomplete.searching' | transloco }}</small>
  }

  @if (showSuggestions) {
    <ul class="address-autocomplete__list">
      @for (s of suggestions; track s.label) {
        <!-- mousedown fires before the input's blur, so the click registers -->
        <li class="address-autocomplete__item" (mousedown)="select(s)">{{ s.label }}</li>
      }
    </ul>
  }
</div>
